/**
 * Время словами (вынесено в T11.10).
 *
 * Мест, где момент показывается человеком, стало четыре: карточка
 * объявления, история уведомлений, срок тарифа и обнуление квоты.
 * Четыре копии одного пересчёта разошлись бы в мелочах — где-то
 * «2 дн назад», где-то «2 дня назад», — и заметить это можно было бы
 * только сравнив экраны рядом.
 *
 * ## Момент передаётся, а не берётся
 *
 * `now` — параметр, а не `Date.now()` внутри. Иначе проверить эти
 * функции можно было бы только подменой системных часов, и «через 6 ч»
 * на границе суток осталось бы непроверенным навсегда.
 */

const MONTHS = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

/** «3 октября». Год добавляется, только если он не текущий. */
export function day(moment: Date, now: Date): string {
  const date = `${String(moment.getDate())} ${MONTHS[moment.getMonth()] ?? ''}`;

  return moment.getFullYear() === now.getFullYear()
    ? date
    : `${date} ${String(moment.getFullYear())}`;
}

/**
 * Сколько времени прошло.
 *
 * Крупными единицами: точность до минуты нужна в первый час — там
 * решается, успел ли человек первым, — а на второй день «46 ч назад»
 * не говорит ничего сверх «2 дн назад».
 *
 * Будущее показывается нулём, а не отрицательным числом: часы телефона
 * и сервера расходятся на секунды, и «−1 мин назад» — это про
 * расхождение часов, а не про объявление.
 */
export function ago(iso: string, now: Date = new Date()): string {
  const moment = new Date(iso);

  if (Number.isNaN(moment.getTime())) return '';

  const minutes = Math.max(0, Math.round((now.getTime() - moment.getTime()) / 60_000));

  if (minutes < 60) return `${String(minutes)} мин назад`;
  if (minutes < 60 * 24) return `${String(Math.round(minutes / 60))} ч назад`;

  return `${String(Math.round(minutes / (60 * 24)))} дн назад`;
}
